const RomaniaFlag = () => (
  <svg width="16" height="12" viewBox="0 0 30 20" style={{ marginRight: '4px', verticalAlign: 'middle' }}>
    <rect width="10" height="20" fill="#002B7F"/>
    <rect x="10" width="10" height="20" fill="#FCD116"/>
    <rect x="20" width="10" height="20" fill="#CE1126"/>
  </svg>
);

export default RomaniaFlag;